import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';
import SociosList from './components/Socios/SociosList';
import SocioDetail from './components/Socios/SocioDetail';
import SocioForm from './components/Socios/SocioForm';
import ReceitasList from './components/Receitas/ReceitasList';
import DespesasList from './components/Despesas/DespesasList';
import BalanceteView from './components/Balancete/BalanceteView';
// import EventosList from './components/Eventos/EventosList';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" /> : <Login />} 
      />
      
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/socios" element={<SociosList />} />
                <Route path="/socios/novo" element={<SocioForm />} />
                <Route path="/socios/:id/editar" element={<SocioForm />} />
                <Route path="/socios/:id" element={<SocioDetail />} />
                <Route path="/receitas" element={<ReceitasList />} />
                <Route path="/despesas" element={<DespesasList />} />
                <Route path="/balancete" element={<BalanceteView />} />
                {/* <Route path="/eventos" element={<EventosList />} /> */}
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
